// extracted by mini-css-extract-plugin
export var cardContainer = "_ne-0";
export var cardHeader = "_ne-2";
export var collapsedState = "_ne-3";
export var dragHandle = "_ne-5";
export var dragHandleIcon = "_ne-6";
export var dragging = "_ne-1";
export var titleArea = "_ne-4";